<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Filter from "@retailer/svelte/Shared/QuickOrderList/Filter.svelte";
  import type { ListFilterValues } from "@shared/types/Filters";
  import type { QuickOrderListParams } from "@shared/types/QuickOrderList";

  export let showFiltersModal: boolean = false;
  export let onCloseMobileFilters: () => void;
  export let applyFilters: (filters: QuickOrderListParams) => void;
  export let filters: QuickOrderListParams;
  export let filterValues: ListFilterValues;
  export let hiddenFilters: string[];

  let filterTypes = [
    { id: "productTypes", name: "Product Type", key: "product_type" },
    { id: "distributors", name: "Distributor", key: "distributor" },
    { id: "containers", name: "Container", key: "container" },
    { id: "categories", name: "Category", key: "category" },
  ];

  const updateFilter = function (filter, selected_value) {
    if (filter["key"] == "distributor") {
      filters[filter["key"]] = selected_value["name"];
    } else if (filter["key"] == "container") {
      filters[filter["key"]] = selected_value;
    } else {
      filters[filter["key"]] = selected_value["id"];
    }
  };

  const clearFilters = function () {
    filterTypes.forEach(filter => {
      if (hiddenFilters.indexOf(filter.key) < 0) {
        filters[filter.key] = null;
      }
    });
    applyFilters(filters);
  };

</script>

<Modal show={showFiltersModal} closeOnBackgroundClick={false} fizzModal={true}>
  <div class="fizz-modal-content" id="list-mobile-filters" style="overflow: scroll;">
    <div class="layout-header-footer">
      <header class="fizz-modal-header">
        <h4 class="fizz-heading-4">Filter by</h4>
        <!-- svelte-ignore a11y-missing-attribute -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <a
          on:click|preventDefault={onCloseMobileFilters}
          class="fizz-modal-toggle fizz-modal-close"
        >
          <Icon type="X" extraClassNames="fizz-text-brand" height="16" width="16" />
        </a>
      </header>

      <dl class="fizz-toggle-details fizz-stack-16 side-filter-wrapper-fizz">
        {#each filterTypes as filter}
          <Filter
            filters={filterValues[filter.id]}
            filter={{
              ...filter,
              value: filters[filter.key],
            }}
            {updateFilter}
            hidden={hiddenFilters.indexOf(filter.key) >= 0}
          />
        {/each}
      </dl>

      <div class="fizz-justify-end fizz-flex-row">
        <button
          class="fizz-button fizz-sidebar-toggle
          fizz-stack-16"
          on:click|preventDefault={clearFilters}>Clear Filters</button
        >
        <button
          class="fizz-button-secondary fizz-sidebar-toggle
          fizz-stack-16 fizz-inline-16"
          on:click|preventDefault={() => applyFilters(filters)}>Apply Filters</button
        >
      </div>
    </div>
  </div>
</Modal>
